var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTokenburn = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m384 1170c-75.602-158.4-36-248.4 22.801-333.6 63.602-93.602 80.398-186 80.398-186s50.398 64.801 30 168c88.801-98.398 105.6-255.6 92.398-316.8 200.4 139.2 286.8 442.8 170.4 668.4 615.6-348 152.4-868.8 72-927.6 26.398 57.602 31.199 158.4-21.602 206.4-91.199-348-318-418.8-318-418.8 26.398 178.8-97.199 375.6-216 522-4.8008-70.801-8.3984-121.2-46.801-189.6-9.6016 130.8-108 236.4-134.4 364.8-36 177.6 26.402 307.2 268.8 442.8z",
    fill: "#00abe6"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTokenburn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tokenburn.7f6a15790cc04d927e9846726e481fce.svg";